<template>
  <v-card>
    <v-card-text v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
      <div v-for="(q, i) in showQuestions" :key="q.id">
        <p class="question">
          No.{{ q.id }} {{ section.subjectWords[type] }} {{ q.question }}
        </p>
        <v-radio-group v-model="value[q.id]" column>
          <div v-for="selectOption in selectOptions" :key="selectOption.value">
            <v-radio
              :label="String(selectOption.value) + '. ' + selectOption.label"
              :value="selectOption.value"
            ></v-radio>
          </div>
        </v-radio-group>
      </div>

      <v-alert :value="error" color="error" icon="warning" outline>
        {{ errorMsg }}
      </v-alert>
    </v-card-text>
    <v-card-text v-else>
      <table>
        <colgroup>
          <col :style="{ width: noWidth + '%' }" />
          <col :style="{ width: questionWidth + '%' }" />
          <col
            :style="{ width: radioBtnWidth + '%' }"
            v-for="selectOption in selectOptions"
            :key="selectOption.value"
          />
        </colgroup>
        <thead>
          <tr>
            <th>No</th>
            <th>Question</th>
            <th
              v-for="selectOption in selectOptions"
              :key="selectOption.value"
              class="radio-btn-cell"
            >
              {{ selectOption.label }}
            </th>
          </tr>
        </thead>
        <tr v-for="q in showQuestions" :key="q.id">
          <td>
            {{ q.id }}
          </td>
          <td>{{ section.subjectWords[type] }} {{ q.question }}</td>
          <td
            v-for="selectOption in selectOptions"
            :key="selectOption.value"
            class="radio-btn-cell"
          >
            <input
              type="radio"
              v-model="value[q.id]"
              :value="selectOption.value"
              v-validate="'required|included:1,2,3,4,5,6'"
              :name="'no_' + q.id"
            />
          </td>
        </tr>
      </table>
      <v-alert :value="error" color="error" icon="warning" outline>
        {{ errorMsg }}
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="backPage">Back</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="nextPage">Next</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  components: {},
  props: ["section", "value", "type"],
  data() {
    return {
      rowRes: null,
      cuurentPage: 1,
      questions: this.section.questions,
      questionsOfOnePage: this.section.questionsOfOnePage,
      selectOptions: this.section.selectOptions,
      error: false,
      errorMsg: "全ての質問に回答してください。/ Answer all questions.",
      noWidth: 3,
      questionWidth: 45,
    };
  },
  created() {},
  computed: {
    endOfPage() {
      return Array.isArray(this.questions)
        ? Math.ceil(this.questions.length / this.questionsOfOnePage)
        : 0;
    },
    endQuestionOfPage() {
      let end = this.cuurentPage * this.questionsOfOnePage;
      return Array.isArray(this.questions)
        ? end > this.questions.length
          ? this.questions.length
          : end
        : 0;
    },
    showQuestions() {
      const startQuestionOfPage =
        (this.cuurentPage - 1) * this.questionsOfOnePage;
      return Array.isArray(this.questions)
        ? this.questions.slice(startQuestionOfPage, this.endQuestionOfPage)
        : [];
    },
    radioBtnWidth() {
      return Math.floor(
        (100 - (this.noWidth + this.questionWidth)) / this.selectOptions.length
      );
    },
  },
  methods: {
    backPage() {
      if (this.cuurentPage == 1) {
        this.$emit("backStep");
      } else {
        this.cuurentPage = this.cuurentPage - 1;
      }
    },
    nextPage() {
      this.$validator.validateAll().then((result) => {
        this.$emit("updateAnswers");
        if (result && this.validate()) {
          this.error = false;
          if (this.cuurentPage == this.endOfPage) {
            this.$emit("nextStep");
          } else {
            this.cuurentPage = this.cuurentPage + 1;
          }
        } else {
          this.error = true;
        }
      });
    },
    validate() {
      let result = true;
      this.showQuestions.forEach((q) => {
        if (this.value[q.id] <= 0) {
          result = false;
        }
      });
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-radio ::v-deep label.v-label {
  font-size: 0.8rem;
}
.v-input--radio-group {
  margin-top: 0px;
}
.question {
  margin-top: 5px;
  margin-bottom: 0px;
}
table {
  border-collapse: collapse;
  table-layout: fixed;
  td,
  th {
    border-collapse: collapse;
    border: 1px solid rgba(0, 0, 0, 0.12);
    //font-size: 8px;
  }
  td {
    word-wrap: break-word;
    padding: 2px;
  }
  td.radio-btn-cell {
    text-align: center;
  }
  th.radio-btn-cell {
    font-size: 12px;
  }
}
</style>


